import { withStyles } from '@material-ui/core/styles';

import styles from './collapsible-card.styles';
import CollapsibleCard from './collapsible-card';

export default withStyles(styles)(CollapsibleCard);
